import { notification } from 'antd';
import type { NotificationPlacement } from 'antd/es/notification/interface';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface NotificationProps {
  type: NotificationType;
  message: string;
  description?: string;
  placement?: NotificationPlacement;
  duration?: number;
}

const useNotification = () => {
  const showNotification = ({ type, message, description, placement = 'topRight', duration = 4.5 }: NotificationProps) => {
    notification[type]({
      message,
      description,
      placement,
      duration,
    });
  };

  const destroyAll = () => {
    notification.destroy();
  };

  return {
    showNotification,
    destroyAll,
  };
};

export default useNotification;

